<template>
    <div class="items-container">
      <h2>Backup & Restore</h2>
  
      <div class="action-buttons">
        <button @click="backupNow" class="save-button">Create Backup</button>
        <button @click="restoreDatabase" class="delete-button">Restore Backup</button>
      </div>
  
      <p class="info-text">
        ✅ Your backup is stored at: 
        <strong>{{ backupLocation }}</strong>
      </p>
  
      <p class="info-text warning">
        ⚠️ <strong>Warning:</strong> Restoring a backup will overwrite all current data.
      </p>
  
      <p class="info-text recommendation">
        🔹 <strong>We strongly recommend copying this file to an external storage device</strong> 
        (USB drive, external hard drive, or cloud storage) to protect against data loss.
      </p>
    </div>
  </template>
  
  <script>
  import api from '@/services/api';
  
  export default {
    data() {
      return {
        backupLocation: "C:\\Users\\Public\\Documents\\LotLedger_Backups\\lotledger.db"
      };
    },
    methods: {
      async backupNow() {
        console.log("🚀 Sending backup request to backend");
  
        try {
          await api.post(`/backup`);
          alert("✅ Backup completed! You can find it at:\n" + this.backupLocation);
        } catch (error) {
          console.error("❌ Backup failed:", error);
          alert("❌ Backup failed. See console for details.");
        }
      },
  
      async restoreDatabase() {
        if (!confirm("⚠️ Are you sure? Restoring will overwrite all current data!")) {
          return;
        }
  
        console.log("🚀 Sending restore request to backend");
  
        try {
          await api.post(`/restore`);
          alert("✅ Database restored successfully!");
        } catch (error) {
          console.error("❌ Restore failed:", error);
          alert("❌ Restore failed. See console for details.");
        }
      }
    }
  };
  </script>
  
  <style scoped>
  /* Backup & Restore Page Styling */
  .items-container {
    padding: 20px;
    font-family: "Poppins", sans-serif !important;
    background: #9cd0f2; /* Light grey-blue */
    border-radius: 10px;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    text-align: center;
  }
  
  h2 {
    color: #2a3a4a;
    margin-bottom: 15px;
  }
  
  /* Buttons */
  .action-buttons {
    display: flex;
    justify-content: center;
    gap: 15px;
    margin-bottom: 15px;
  }
  
  .save-button, .delete-button {
    padding: 12px 20px;
    font-size: 16px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-weight: bold;
  }
  
  /* Backup Button */
  .save-button {
    background-color: #327ba8; /* Deep blue */
    color: white;
  }
  
  .save-button:hover {
    background-color: #286c98; /* Darker blue */
  }
  
  /* Restore Button */
  .delete-button {
    background-color: #9f3207; /* Deep red */
    color: white;
  }
  
  .delete-button:hover {
    background-color: #1f2a35; /* Darker red */
  }
  
  /* Informational Text */
  .info-text {
    font-size: 14px;
    margin-top: 10px;
    color: #333;
  }
  
  .warning {
    color: #9f3207; /* Deep red warning */
    font-weight: bold;
  }
  
  .recommendation {
    color: #237a4b; /* Green recommendation */
    font-weight: bold;
  }
  </style>
  